import css from 'styled-jsx/css'

export const styles = css`
  .userInfo {
    display: flex;
    align-items: center;
  }
  .userInfo__img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .userInfo__block {
    overflow: hidden;
    display: inline-flex;
    margin: 0 10px;
    flex-direction: column;
    justify-content: center;
    flex: 1;
  }
  .userInfo__block a {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 1.2rem;
  }
  .userInfo__name {
    color: #000;
  }
  .userInfo__des {
    margin-top: 3px;
    color: #999;
    font-size: 0.8rem;
  }
  a,
  a:link,
  a:visited,
  a:hover,
  a:active {
    text-decoration: none;
  }
`
